import { useTheme } from '@mui/material/styles'
import { FITNESS_METRICS } from '../Utils/utils'
import { hourPropType } from '../Utils/types'

const FitnessRings = ({ stats }) => {
  const theme = useTheme()

  return (
    <svg
      viewBox="0 0 120 120"
      style={{ width: '100%', height: 'auto', display: 'block' }}
    >
      {Object.entries(FITNESS_METRICS).map(([key, { colour, radius }]) => {
        const { value, target } = stats[key]

        const circumference = 2 * Math.PI * radius
        const percentage = target > 0 ? Math.min(value / target, 1) : 0
        const offset = circumference * (1 - percentage)

        return (
          <g key={key} transform="rotate(-90 60 60)">
            <circle
              cx="60"
              cy="60"
              r={radius}
              fill="none"
              stroke={theme.palette.divider}
              strokeWidth="8"
            />

            <circle
              cx="60"
              cy="60"
              r={radius}
              fill="none"
              stroke={colour}
              strokeWidth="8"
              strokeLinecap="round"
              strokeDasharray={circumference}
              strokeDashoffset={offset}
              style={{
                transition: 'stroke-dashoffset 0.5s ease',
              }}
            />
          </g>
        )
      })}
    </svg>
  )
}

FitnessRings.propTypes = {
  stats: hourPropType.isRequired,
}

export default FitnessRings
